import { defineMessages } from 'react-intl';
/* Extracted from src/java/com/savagebeast/radioesque/RadioApplicationErrorEnum.java */

/* Registration */
export const AUTH_SHOW_CAPTCHA = 'AUTH_SHOW_CAPTCHA';
export const BIRTH_YEAR_INVALID = 'BIRTH_YEAR_INVALID';
export const BIRTH_YEAR_TOO_YOUNG = 'BIRTH_YEAR_TOO_YOUNG';
export const EMAIL_MALFORMED_ADDRESS = 'EMAIL_MALFORMED_ADDRESS';
export const GENDER_INVALID = 'GENDER_INVALID';
export const INVALID_PASSWORD_RESET_TOKEN = 'ERROR_INVALID_PASSWORD_RESET_TOKEN';
export const LISTENER_DUPLICATE_USERNAME = 'LISTENER_DUPLICATE_USERNAME'; // attempting to register an existing user
export const LISTENER_INVALID_PASSWORD = 'LISTENER_INVALID_PASSWORD';
export const LISTENER_MALFORMED_USERNAME = 'LISTENER_MALFORMED_USERNAME'; // username (email) malformed
export const LISTENER_PASSWORD_TOO_SHORT = 'LISTENER_PASSWORD_TOO_SHORT';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const ZIP_CODE_INVALID = 'ZIP_CODE_INVALID';

// Value specific to axios error handling
export const CONNECTION_ABORTED = 'ECONNABORTED';
export const NETWORK_ERROR = 'Network Error';

export const ServiceErrorMessages = defineMessages({
  advertiserAccountDeletionWarning: {
    id: 't.advertiserAccountDeletionWarning',
    defaultMessage:
      'This is an advertiser account which hosts stations for other listeners. The delete button has been disabled here for safety. Please navigate to Kraken if you wish to modify stations on this account.',
  },
  genericServiceErrorMessage: {
    id: 't.genericServiceErrorMessage',
    defaultMessage:
      "Something has gone wrong. We're working on this issue, and we'll have things back to normal soon.",
  },
  genericServiceErrorTitle: {
    id: 't.genericServiceErrorTitle',
    defaultMessage: 'Internal Server Error',
  },
  offlineNotificationMessage: {
    id: 't.offlineNotificationMessage',
    defaultMessage: "Poor network connection. Listening will resume when it's restored",
  },
  ok: {
    id: 't.ok',
    defaultMessage: 'OK',
  },
  podcastEpisodeUnavailable: {
    id: 't.podcastEpisodeUnavailable',
    defaultMessage:
      'We are not able to play the podcast audio from the provider. Please try again later.',
  },
  readOnlyModeBodyMessage: {
    id: 't.readOnlyModeBodyMessage',
    defaultMessage:
      'Pandora is currently performing maintenance. You can continue listening to music, but some features may be temporarily unavailable. We’ll be back as soon as possible.',
  },
  readOnlyModeHeaderMessage: {
    id: 't.readOnlyModeHeaderMessage',
    defaultMessage: "We'll be right back",
  },
  suspendedListenerErrorMessage: {
    id: 't.suspendedListenerErrorMessage',
    defaultMessage:
      'Sorry, your account has been suspended. For help, contact Listener Support at <<pandora-support@pandora.com.>>',
  },
} as const);
